<template>
  <div>
    <v-card tile>
      <v-card-title>
        <h3>Deposit</h3>
      </v-card-title>
      <v-divider></v-divider>

      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="deposit"
              :disabled="!$can('edit', 'case-deposit')"
              :rules="depositRules"
              label="Amount"
              prefix="$"
            >
              <template v-slot:append>
                <v-btn color="primary"
                       :disabled="!$can('edit', 'case-deposit')"
                       flat
                       :loading="loading"
                       @click="changeDeposit"
                >Save deposit and send receipt</v-btn>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <div class="description">
              No spaces allowed. Only "-", ".", "0-9". Correct values examples: "-10.99", "23.35", "16"
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-card tile>
      <v-card-title>
        <h3>Balance Payable (excluding readjustment value)</h3>
      </v-card-title>
      <v-divider></v-divider>

      <v-container>
        <v-layout row wrap>
          <v-text-field
            :disabled="true"
            :value="leftToPay"
            label="Amount"
            prefix="$"
            class="disabled-active"
          />
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import plansAPI from '@/api/resources/plans'
  import casesAPI from '@/api/resources/cases'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      caseModel: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters({}),
      leftToPay () {
        const gst = this.quotationTotalPrice / 100 * 8
        const val = this.quotationTotalPrice + gst - Number(this.deposit) + Number(this.readjustment)
        return Math.round((val + Number.EPSILON) * 100) / 100
      }
    },
    data () {
      return {
        snackbar: false,
        loading: false,
        deposit: this.caseModel.deposit || 0,
        readjustment: this.caseModel.readjustment || 0,
        quotationTotalPrice: 0,
        planData: {},
        depositRules: [
          value => {
            let rules = true

            if (value.indexOf(',') >= 0) {
              rules = 'No commas allowed'
            }
            if (value.indexOf(' ') >= 0) {
              rules = 'No spaces allowed'
            }
            if (/[a-z]/i.test(value)) {
              rules = 'No letters allowed'
            }
            if (value[0] === '0') {
              rules = 'No leading 0 allowed'
            }
            if (value.indexOf('+') >= 0) {
              rules = 'No plus signs allowed'
            }

            return rules
          }
        ]
      }
    },
    watch: {
      timeStart (newVal) {
        if (newVal.indexOf(':') !== -1) {
          this.menuTimeStart.state = false
        }
      },
      caseModel (c) {
        this.deposit = c.deposit || 0
      }
    },
    methods: {
      changeDeposit () {
        this.loading = true
        const deposit = Number(this.deposit)
        this.$store.dispatch('updateCase', { case_id: this.caseModel.id, payload: { deposit } }).then(() => {
          this.$store.dispatch('getCaseInvoices', this.caseModel.id)
          this.$store.dispatch('getCaseLog', this.caseModel.id)
          this.loading = false
        })
      }
    },
    created () {
      plansAPI.loadPlan(this.caseModel.plans_id).then(result => {
        this.planData = result
      })

      casesAPI.getQuotationTotalPrice(this.caseModel.id).then(result => {
        this.quotationTotalPrice = result
      }, () => {})
    }
  }
</script>

<style>
  .disabled-active input {
    color: rgba(0,0,0,0.87) !important;
  }
</style>



// WEBPACK FOOTER //
// CaseDeposit.vue?965b1e16